import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["scrollArea", "tooltip"]

  connect() {
    this.scrollAreaTarget.addEventListener("mousemove", this.onMouseMove)
    this.scrollAreaTarget.addEventListener("mouseleave", this.onMouseLeave)
    this.updateMask()

    // Tooltip delegation on icon hover
    this.icons = this.scrollAreaTarget.querySelectorAll("[data-tooltip]")
    this.icons.forEach((icon) => {
      icon.addEventListener("mouseenter", this.showTooltip)
      icon.addEventListener("mouseleave", this.hideTooltip)
    })
  }

  disconnect() {
    this.scrollAreaTarget.removeEventListener("mousemove", this.onMouseMove)
    this.scrollAreaTarget.removeEventListener("mouseleave", this.onMouseLeave)
    this.icons?.forEach((icon) => {
      icon.removeEventListener("mouseenter", this.showTooltip)
      icon.removeEventListener("mouseleave", this.hideTooltip)
    })
  }

  onMouseMove = (event) => {
    const rect = this.scrollAreaTarget.getBoundingClientRect()
    const ratio = (event.clientX - rect.left) / rect.width
    const maxScroll =
      this.scrollAreaTarget.scrollWidth - this.scrollAreaTarget.clientWidth
    this.scrollAreaTarget.scrollLeft = ratio * maxScroll
    this.updateMask()
  }

  onMouseLeave = () => {
    this.updateMask()
  }

  showTooltip = (event) => {
    const icon = event.currentTarget
    const text = icon.dataset.tooltip
    if (!text || !this.hasTooltipTarget) return

    const tooltip = this.tooltipTarget
    tooltip.textContent = text
    tooltip.classList.remove("opacity-0")
    tooltip.classList.add("opacity-100")

    const iconRect = icon.getBoundingClientRect()
    tooltip.style.position = "fixed"
    tooltip.style.left = `${iconRect.left + iconRect.width / 2}px`
    tooltip.style.top = `${iconRect.top - 4}px`
    tooltip.style.transform = "translate(-50%, -100%)"
  }

  hideTooltip = () => {
    if (!this.hasTooltipTarget) return
    this.tooltipTarget.classList.remove("opacity-100")
    this.tooltipTarget.classList.add("opacity-0")
  }

  updateMask() {
    const { scrollLeft, scrollWidth, clientWidth } = this.scrollAreaTarget
    const maxScroll = scrollWidth - clientWidth

    if (maxScroll <= 0) {
      this.scrollAreaTarget.style.maskImage = "none"
      return
    }

    const fadeSize = 12 // px
    const leftPct = scrollLeft > 1 ? fadeSize : 0
    const rightPct = scrollLeft < maxScroll - 1 ? fadeSize : 0

    this.scrollAreaTarget.style.maskImage = `linear-gradient(to right, transparent 0px, black ${leftPct}px, black calc(100% - ${rightPct}px), transparent 100%)`
  }
}
